import _ from 'lodash'
import axios from 'axios'

const cancelToken = axios.CancelToken

const RequestTracker = {

  requests: {},

  limitedResources: {
    accounts: {
      regex: new RegExp('^accounts/\\d+$')
    },
    companies: {
      regex: new RegExp('^companies/\\d+$')
    },
    activity: {
      regex: new RegExp('^accounts/\\d+/activity')
    },
    propertyMap: {
      regex: new RegExp('^account_properties/\\d+/map')
    },
    propertyTypes: { // metric
      regex: new RegExp('^accounts/\\d+/property-types')
    },
    accountProperties: {
      regex: new RegExp('(?=.*\\baccount_properties\\b)(?=.*\\bfilter__account_id=\\d+\\b).*$')
    },
    accountInvites: {
      regex: new RegExp('(?=.*\\baccount_invites\\b)(?=.*\\baccount_id=\\d+\\b).*$')
    }
  },

  addPendingRequest (url, method) {
    let resourceKey = this.shouldLimitRequest(url, method)

    if (!_.isNull(resourceKey)) {
      let cancellationToken = cancelToken.source()
      this.cancelPendingRequest(resourceKey)
      this.requests[resourceKey] = cancellationToken

      return cancellationToken.token
    }

    return null
  },

  shouldLimitRequest (url, method) {
    if (method !== 'GET' && method !== 'get') {
      return null
    }

    let resourceKey = null

    _.each(this.limitedResources, function (regex, itemKey) {
      if (regex.regex.test(url)) {
        resourceKey = itemKey
        return false
      }
    })

    return resourceKey
  },

  getResourceKey (url) {
    return url.split('/')[0]
  },

  cancelPendingRequest (resourceKey) {
    if (_.has(this.requests, resourceKey)) {
      this.requests[resourceKey].cancel('Request canceled')
      delete this.requests[resourceKey]
    }
  }

}

export default RequestTracker



// WEBPACK FOOTER //
// ./src/functions/RequestTracker.js